import React from 'react';

import { StyleSheet, View } from 'react-native';

import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';
import { routes } from 'utils/routing';

import { TermsLink } from './styled';

const Bullet = ({ label, value }: { label: string; value: string }) => (
  <View style={styles.bullet}>
    <Typography variant="bodyOne" bold>
      • {label} <Typography variant="bodyOne">{value}</Typography>
    </Typography>
  </View>
);

export const DeliveryTermsCanada = () => {
  return (
    <>
      <Typography variant="headerThree" style={styles.title}>
        {t('deliveryTerms.title.ca')}
      </Typography>
      <Typography variant="bodyOne" style={styles.body}>
        {t('deliveryTerms.intro.ca.part1')}
      </Typography>
      <Typography variant="bodyOne" style={styles.body}>
        {t('deliveryTerms.intro.ca.part2')}
      </Typography>
      <Typography variant="bodyOne" style={styles.body}>
        {t('deliveryTerms.intro.ca.part3')}
      </Typography>

      <Typography variant="headerThree" style={styles.sectionHeading}>
        {t('deliveryTerms.ca.heading')}
      </Typography>
      <View style={styles.list}>
        <Bullet
          label={t('deliveryTerms.fee.ca.lt12.label')}
          value={t('deliveryTerms.fee.ca.lt12.value')}
        />
        <Bullet
          label={t('deliveryTerms.fee.ca.gte12.label')}
          value={t('deliveryTerms.fee.ca.gte12.value')}
        />
      </View>

      <TermsLink to={routes.mobileOrderTerms}>
        <Typography variant="headerThree" style={styles.mobileTermsTitle}>
          {t('deliveryTerms.ca.mobileTitle')}
        </Typography>
      </TermsLink>
    </>
  );
};

const styles = StyleSheet.create({
  body: {
    marginBottom: spacing.$4,
  },
  bullet: {
    marginBottom: spacing.$2,
  },
  list: {
    paddingLeft: spacing.$4,
  },
  mobileTermsTitle: {
    marginTop: spacing.$4,
  },
  sectionHeading: {
    marginBottom: spacing.$2,
  },
  title: {
    marginBottom: spacing.$4,
  },
});
